import { AutomatedElements, ImageLetterModel } from './eng-letter.model';
import { TemplateContentModel } from './paginated-view.model';

export class LetterS3Model {
  coverHeaderData: ImageLetterModel;
  contentHeaderData: ImageLetterModel;
  coverFooterData: ImageLetterModel;
  contentFooterData: ImageLetterModel;
  coverLetter: any[];
  Subject: Record<string, any>;
  content: TemplateContentModel[];
  signatures: any[];
  createdDate: number;
  engagementLetterName: string;
  typeOfTemplate: string;
  signatureSrc: string;
  signHeader: string;
  signatureDesignation: string;
  signatureName: string;
  isLetterEditedAfterSend: boolean;
  contentBeforeEdit: TemplateContentModel[];
  componentConfig: ComponentConfigModel;
  elements: AutomatedElements;
  selectedDate: string;
  engLetterInfo: Record<string, any>;

  constructor(data?: Partial<LetterS3Model>) {
    this.coverHeaderData = data?.coverHeaderData || null;
    this.contentHeaderData = data?.contentHeaderData || null;
    this.coverFooterData = data?.coverFooterData || null;
    this.contentFooterData = data?.contentFooterData || null;
    this.coverLetter = data?.coverLetter || [];
    this.Subject = data?.Subject || {};
    this.content = data?.content || [];
    this.signatures = data?.signatures || [];
    this.createdDate = data?.createdDate || 0;
    this.engagementLetterName = data?.engagementLetterName || '';
    this.typeOfTemplate = data?.typeOfTemplate || '';
    this.signatureSrc = data?.signatureSrc || '';
    this.signHeader = data?.signHeader || '';
    this.signatureDesignation = data?.signatureDesignation || '';
    this.signatureName = data?.signatureName || '';
    this.isLetterEditedAfterSend = data?.isLetterEditedAfterSend || false;
    this.contentBeforeEdit = data?.contentBeforeEdit || [];
    this.componentConfig = data?.componentConfig || new ComponentConfigModel();
    this.selectedDate = data?.selectedDate || '';
    this.engLetterInfo = data?.engLetterInfo || null;
  }
}

export class ComponentConfigModel {
  headerConfig: CONFIG_OPTIONS = CONFIG_OPTIONS.ALL_PAGES;
  footerConfig: CONFIG_OPTIONS = CONFIG_OPTIONS.ALL_PAGES;
  hasNoHeaderFooter: boolean = false
}

export enum CONFIG_OPTIONS {
  ALL_PAGES = "ALL_PAGES",
  ONLY_FIRST_PAGE = "ONLY_FIRST_PAGE",
  ONLY_LAST_PAGE = "ONLY_LAST_PAGE",
  NONE = 'NO_PAGE',
}

export interface HFConfigModel {
  label: string;
  value: CONFIG_OPTIONS;
  section: 'HEADER' | 'FOOTER' | 'GLOBAL';
}
